import api from './api';

export const getAllStudents = async () => {
  const response = await api.get('/students/');
  return response.data;
};

export const getStudentById = async (studentId) => {
  const response = await api.get(`/students/${studentId}`);
  return response.data;
};

export const getMyStudentProfile = async () => {
  const response = await api.get('/students/me');
  return response.data;
};

export const createSelfAccount = async (studentData) => {
  const response = await api.post('/students/create_self', studentData);
  return response.data;
};

export const getMyStudentProjects = async () => {
  const response = await api.get('/students/me/projects');
  return response.data;
};

export const getMyStudentClasses = async () => {
  const response = await api.get('/students/me/classes');
  return response.data;
};

export const getMyStudentAttendance = async () => {
  const response = await api.get('/students/me/attendance');
  return response.data;
};

export const getMyStudentAssignments = async () => {
  const response = await api.get('/students/me/assignments');
  return response.data;
};

export const submitAssignment = async (assignmentId, submissionText, submissionFileUrl) => {
  const response = await api.post(
    `/students/me/assignments/${assignmentId}/submit`,
    null,
    {
      params: {
        submission_text: submissionText,
        submission_file_url: submissionFileUrl
      }
    }
  );
  return response.data;
};

export const getMyAssignmentSubmission = async (assignmentId) => {
  const response = await api.get(`/students/me/assignments/${assignmentId}/submission`);
  return response.data;
};

export const createStudent = async (studentData) => {
  const response = await api.post('/students/', studentData);
  return response.data;
};

export const updateStudent = async (studentId, studentData) => {
  const response = await api.put(`/students/${studentId}`, studentData);
  return response.data;
};

export const deleteStudent = async (studentId) => {
  const response = await api.delete(`/students/${studentId}`);
  return response.data;
};

export const enrollStudentInProject = async (projectId, studentId) => {
  const response = await api.post('/students/enroll-in-project', null, {
    params: { project_id: projectId, student_id: studentId }
  });
  return response.data;
};

export const removeStudentFromProject = async (projectId, studentId) => {
  const response = await api.delete('/students/remove-from-project', {
    params: { project_id: projectId, student_id: studentId }
  });
  return response.data;
};

export const suspendStudent = async (userId, reason = null) => {
  const response = await api.post(`/auth/suspend-user/${userId}`, null, {
    params: { reason }
  });
  return response.data;
};

export const unsuspendStudent = async (userId) => {
  const response = await api.post(`/auth/unsuspend-user/${userId}`);
  return response.data;
};